import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"border-bottom":"1px solid #f1f1f1","padding":"0","margin":"0","padding-bottom":"15px"} }
const _hoisted_2 = { class: "fc-dang" }
const _hoisted_3 = { class: "fc-dang" }

import { ref, reactive, unref } from 'vue';
import { ElForm, ElMessage } from 'element-plus';
import { any } from 'vue-types';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';

export default /*#__PURE__*/_defineComponent({
  emits: ['savePlan'],
  setup(__props, { expose, emit: $emits }) {

const { t } = useLocales();



const schema = ref<any>({});
const formRef = ref<InstanceType<typeof ElForm>>();

/* 计算参数 */
const calculateCfg = ref<any>({
	amount: 0.0,
	amountTotal: 0.0,
	maxAmount: 0.0,
	maxScalc: 0.0,
});

/* 自定义验证方法 */
const validate = {
	amount: (rule: any, value: any, callback: any) => {
		const limit = unref(calculateCfg);
		const totalAmt = limit.amount - parseFloat((limit.amountTotal || 0) + '');

		if (!value || isNaN(value)) {
			callback(new Error(t('payplanDialog.message.enterNumber', '请输入数字')));
		}
		if (value <= 0) {
			callback(new Error(t('payplanDialog.message.amountNotZero', '款项金额不能小于等于零')));
		} else if (value.toString().indexOf('.') !== -1 && value.toString().split('.')[1].length > 2) {
			callback(new Error(t('payplanDialog.message.decimalPlaces', '小数点后最多保留两位')));
		} else if (value > totalAmt && !state.isEdit) {
			callback(new Error(t('payplanDialog.message.amountExceedsTotal', '款项金额已超出合同总额，当前已设置款项总金额：${totalAmt}').replace('${totalAmt}', totalAmt.toString())));
		} else {
			callback();
		}
	},
};

const state = reactive({
	show: false,
	title: t('payplanDialog.title', '付款计划'),
	loading: false,
	isEdit: false,
	rules: {
		name: [{ required: true, message: t('bill.planName', '款项名称不能为空'), trigger: 'blur' }],
		pay_condition: [{ required: true, message: t('performs.table.planCondition', '款项条件不能为空'), trigger: 'blur' }],
		amount: [{ required: true, message: t('bill.planAmount', '款项金额不能留空'), trigger: 'blur' }, { validator: validate.amount }],
	},
	disabledAmt: false,
});

const actions = {
	save: () => {
		state.show = false;
		$emits('savePlan', unref(schema),state.isEdit);

	},
	close: () => {
		state.show = false;
	},
};

const changes = {
	amount: (amount: number) => {
		if (amount <= 0) return;
		const limit = unref(calculateCfg);
		unref(schema).scale = Number(((amount / limit.amount) * 100).toFixed(2));
	},
	scale: (val: number) => {
		const limit = unref(calculateCfg);
		const scale = val > limit.maxScalc ? limit.maxScalc : val;
		unref(schema).amount = Number((limit.amount * (scale / 100)).toFixed(2));
	},
};

const expFuncs = {
	openDialog: (ctamount: number, payment: string, planList: any[]) => {
		/* 计算当前已设置金额/比例 */
		// const amtTotal = planList.reduce((tol: number, plan: any) => Number.parseFloat(`${tol}`) + Number.parseFloat(`${plan.amount}`), 0);
		// const amtScalc = planList.reduce((tol: number, plan: any) => Number.parseFloat(`${tol}`) + Number.parseFloat(`${plan.scale}`), 0);
		// 先乘100再除100解决js小数计算精度问题(保留两位小数的情况)
		const amtTotal = planList.reduce((tol: number, plan: any) => tol + (plan.amount * 100.00), 0) / 100;
		const amtScalc = planList.reduce((tol: number, plan: any) => tol + (plan.scale * 100.00), 0) / 100;
		console.log('payplanDialog -> openDialog -> amtTotal, amtScalc', amtTotal, amtScalc + '%');
		if (amtTotal >= ctamount) {
			ElMessage.error(t('payplan.message.totalExceedsContract', '付款计划总金额大于合同总金额，不能添加付款计划'));
			return;
		}
		/* 计算剩余可设置金额/比例 */
		// var _maxAmount = Number(((ctamount * 100 - amtTotal * 100) / 100).toFixed(2));
		// var _maxScalc = Number(((100 * 100 - amtScalc * 100) / 100).toFixed(2));
		// 先乘100再除100解决js小数计算精度问题(保留两位小数的情况)
		var _maxAmount = (ctamount * 100 - amtTotal * 100) / 100;
		var _maxScalc = (100 * 100 - amtScalc * 100) / 100;
		const config = {
			amount: ctamount,
			amountTotal: amtTotal,
			maxAmount: _maxAmount,
			maxScalc: _maxScalc,
		};
		console.log('payplanDialog -> openDialog -> config', config);
		schema.value = {};
		calculateCfg.value = config;

		if (payment == 'Y') {
			unref(schema).amount = ctamount;
			unref(schema).scale = 100;
		} else {
			unref(schema).amount = config.maxAmount;
			unref(schema).scale = config.maxScalc;
		}

		/* 如果时一次性付款，则禁用“申请金额”和“付款比例字段” */
		state.disabledAmt = payment == 'Y' ? true : false;
		state.isEdit = false;
		state.show = true;
	},

	editDialog: (ctamount: number, payment: string, planList: any[], row: any) => {
		/* 计算当前已设置金额/比例 */
		// const amtTotal = planList.reduce((tol: number, plan: any) => Number.parseFloat(`${tol}`) + Number.parseFloat(`${plan.amount}`), 0);
		// const amtScalc = planList.reduce((tol: number, plan: any) => Number.parseFloat(`${tol}`) + Number.parseFloat(`${plan.scale}`), 0);
		// 先乘100再除100解决js小数计算精度问题(保留两位小数的情况)
		const amtTotal = planList.reduce((tol: number, plan: any) => tol + ((plan.amount) * 100.00), 0) / 100;
		const amtScalc = planList.reduce((tol: number, plan: any) => tol + ((plan.scale) * 100.00), 0) / 100;
		console.log('payplanDialog -> openDialog -> amtTotal, amtScalc', amtTotal, amtScalc + '%');
		// if (amtTotal >= ctamount) {
		// 	ElMessage.error('付款计划总金额大于合同总金额，不能添加付款计划');
		// 	return;
		// }
		/* 计算剩余可设置金额/比例 */
		// var _maxAmount = Number(((ctamount * 100 - amtTotal * 100) / 100).toFixed(2));
		// var _maxScalc = Number(((100 * 100 - amtScalc * 100) / 100).toFixed(2));
		// 先乘100再除100解决js小数计算精度问题(保留两位小数的情况)
		var _maxAmount = (ctamount * 100 - amtTotal * 100 + row.amount * 100) / 100;
		var _maxScalc = (100 * 100 - amtScalc * 100 + row.scale * 100) / 100;
		const config = {
			amount: ctamount,
			amountTotal: amtTotal,
			maxAmount: _maxAmount,
			maxScalc: _maxScalc,
		};
		console.log('payplanDialog -> openDialog -> config', config);
		schema.value = {};
		calculateCfg.value = config;

		// if (payment == 'Y') {
		// 	unref(schema).amount = ctamount;
		// 	unref(schema).scale = 100;
		// } else {
		// 	unref(schema).amount = config.maxAmount;
		// 	unref(schema).scale = config.maxScalc;
		// }
		schema.value = row;
		/* 如果时一次性付款，则禁用“申请金额”和“付款比例字段” */
		state.disabledAmt = payment == 'Y' ? true : false;
		state.isEdit = true;		
		state.show = true;
	},
};

expose({ ...expFuncs });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).show) = $event)),
    width: "600"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(state).title), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: _unref(state).loading,
        onClick: actions.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save', '保存')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (!_unref(state).isEdit)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            type: "info",
            disabled: _unref(state).loading,
            onClick: actions.close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('buttons.closed', '关闭')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
        ref_key: "formRef",
        ref: formRef,
        size: "small",
        model: schema.value,
        rules: _unref(state).rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('payplanDialog.form.contractAmount', '合同金额')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: calculateCfg.value.amount,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((calculateCfg.value.amount) = $event)),
                        disabled: "",
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('bill.planName', '款项名称'),
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schema.value.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schema.value.name) = $event)),
                        type: "text",
                        placeholder: _unref(t)('payplanDialog.placeholder.enterPlanName', '请输入款项名称')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('performs.table.planCondition', '款项条件'),
                    prop: "pay_condition"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: schema.value.pay_condition,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schema.value.pay_condition) = $event)),
                        type: "text",
                        placeholder: _unref(t)('payplanDialog.placeholder.enterPlanCondition', '请输入款项条件')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "amount" }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('payplanDialog.form.applyAmount', '申请金额')) + "，" + _toDisplayString(_unref(t)('payplanDialog.label.maxAmount', '可设最大金额：')), 1),
                      _createElementVNode("span", _hoisted_2, _toDisplayString(calculateCfg.value.maxAmount.toLocaleString()), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        class: "w100",
                        modelValue: schema.value.amount,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schema.value.amount) = $event)),
                        disabled: _unref(state).disabledAmt,
                        precision: 2,
                        step: 1,
                        max: calculateCfg.value.maxAmount,
                        onChange: changes.amount
                      }, null, 8, ["modelValue", "disabled", "max", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('payplanDialog.form.applyScale', '款项比例（百分比(%)）')
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('performs.table.planScale', '款项比例')) + " ", 1),
                      _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(_unref(t)('payplanDialog.label.percentage', '百分比：%)')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        class: "w100",
                        modelValue: schema.value.scale,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schema.value.scale) = $event)),
                        disabled: _unref(state).disabledAmt,
                        precision: 2,
                        step: 10,
                        max: calculateCfg.value.maxScalc,
                        onChange: changes.scale
                      }, null, 8, ["modelValue", "disabled", "max", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('performs.table.plannedPayDate', '计划付款日期'),
                    prop: "pay_date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        class: "w100",
                        modelValue: schema.value.pay_date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schema.value.pay_date) = $event)),
                        type: "date",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD",
                        placeholder: _unref(t)('payplanDialog.placeholder.selectPlannedPayDate', '请选择计划付款日期')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('categorys.table.remark', '备注')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: "2",
                        modelValue: schema.value.remark,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schema.value.remark) = $event)),
                        placeholder: _unref(t)('payplanDialog.placeholder.enterRemark', '请输入款项备注')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})